import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import RestaurantLayout from "./RestaurantLayout";
import PromoPage from "./PromoPage";
import i18n from "../i18n";
import DeliveryTypeLayout from "./DeliveryTypeLayout";
import { getLanguageById } from "../helpers/language";
import moment from "moment";
import "moment/locale/he";
import "moment/locale/ru";
import LoadingModal from "../IPosModal/LoadingModal";
import { loadBranchInfo } from "../redux/actions/branchActions";
import { hideLoading, showLoading } from "../redux/actions/loadingActions";
import { Helmet } from "react-helmet";
import { getImageUrl } from "../api/iposApi";
import ErrorLayout from "./ErrorLayout";
import { isMobileApp } from "../helpers/common";
import iposLogo from "../assets/img/promo_page/iPos_Logo.png";
import OrderInfoLayout from "./OrderInfoLayout";
import GreenBillLayout from "./GreenBillLayout";
import InvoiceLayout from "./InvoiceLayout";
import { setDeliveryType, setTableId } from "../redux/actions/baseActions";
import { DeliveryType } from "../constants/deliveryTypes";
import TagManager from "react-gtm-module";
import { BeerTimeMetaPixel } from "../utils/clients/beertime_meta_pixel";
import MemberBreadcafePage from "../pages/member_registration/MemberBreadcafePage";
import MemberBreadstationPage from "../pages/member_registration/MemberBreadstationPage";
import PaymentSuccessPage from "../pages/payment/PaymentSuccessPage";

import "./BaseLayout.scss";

const GOOGLE_API_KEY = "AIzaSyCbGCUYrMZYj-LdlsRJIeHg60ekgDPwczw";

const loadScript = (url, callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

const BaseLayout = ({
  history,
  currentLanguageId,
  currentUiLanguageId,
  currentDeliveryType,
  loading,
  loadBranchInfo,
  branchInfo,
  showLoading,
  hideLoading,
  setDeliveryType,
  setTableId,
}) => {
  useEffect(() => {    
    load();
    // load().finally(() => {
    //   hideLoading();
    // });
  }, [currentLanguageId, currentUiLanguageId]);

  const load = async () => {
    //showLoading();
    const lang = getLanguageById(currentUiLanguageId);
    i18n.changeLanguage(lang);
    moment.locale(lang);
    document.querySelector("html").dir = lang === "he" ? "rtl" : "ltr";
    if (branchInfo && branchInfo.branch_guid_code) {
      const branch = await loadBranchInfo(branchInfo.branch_guid_code);

      if (
        branch &&
        branch.branch_guid_code &&
        branch.branch_guid_code === "i71m82f5-922d-4390-ba3e-49431746slc2"
      ) {
        const tagManagerArgs = {
          gtmId: "G-QNNETE36JG",
        };

        TagManager.initialize(tagManagerArgs);
      }
    }
    //hideLoading();
  };

  // useEffect(() => {
  //   // showLoading();
  // }, [branchInfo]);

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&language=he&libraries=places`,
      () => {}
    );
  }, []);

  const currentLogo = () => {
    if (branchInfo.LogoImageName) {
      return getImageUrl(branchInfo.LogoImageName);
    }

    return iposLogo;
  };

  return (
    <ConnectedRouter history={history}>
      {branchInfo && (
        <Helmet>
          <title>{branchInfo.PlaseName}</title>
          <link rel="icon" href={currentLogo()} />
          <link rel="apple-touch-icon" sizes="76x76" href={currentLogo()} />
          <link rel="apple-touch-icon" sizes="192x192" href={currentLogo()} />
          <link rel="apple-touch-icon" sizes="512x512" href={currentLogo()} />

          <link rel="pple-touch-icon-precomposed" href={currentLogo()} />
        </Helmet>
      )}
      {branchInfo.branch_guid_code ===
        "c42b10f5-69qw-1253-be9a-09539044gbf5" && <BeerTimeMetaPixel />}

      <div className={`layout ${isMobileApp() ? "mobile_app" : ""}`}>
        {/*<div className={ `layout ${'mobile_app'}` }>*/}
        <LoadingModal show={loading.show} text={loading.text} />

        <Switch>
          <Route exact path="/" component={PromoPage} />
          <Route
            exact
            path="/member-breadstation"
            component={MemberBreadstationPage}
          />
          <Route
            exact
            path="/member-breadcafe"
            component={MemberBreadcafePage}
          />
          <Route exect path="/:branchId/type" component={DeliveryTypeLayout} />
          <Route
            exact
            path="/:branchId/payment-success"
            component={PaymentSuccessPage}
          />
          <Route
            exect
            path="/:branchId/order_info/:orderId"
            component={OrderInfoLayout}
          />
          <Route
            exect
            path="/:branchId/green_bill/:orderId"
            component={GreenBillLayout}
          />
          <Route
            exect
            path="/:branchId/invoice/:orderId"
            component={InvoiceLayout}
          />
          <Route exect path="/:branchId/error" component={ErrorLayout} />
          <Route
            path={["/:branchId/order/:tableId"]}
            render={(props) => {
              const { tableId } = props.match.params;
              if (tableId.trim()) {
                setDeliveryType(DeliveryType.EAT_IN);
                setTableId(parseInt(tableId.trim()));
                return <RestaurantLayout />;
              }

              return <Redirect to={`/${props.match.params.branchId}/type`} />;
            }}
          />
          <Route
            path={["/:branchId"]}
            render={(props) =>
              currentDeliveryType ? (
                <RestaurantLayout />
              ) : (
                <Redirect to={`/${props.match.params.branchId}/type`} />
              )
            }
          />
        </Switch>
      </div>
    </ConnectedRouter>
  );
};

const mapStateToProps = (state) => {
  const {
    currentLanguageId,
    currentUiLanguageId,
    currentDeliveryType,
    loading,
    branchInfo,
  } = state;

  return {
    currentLanguageId,
    currentUiLanguageId,
    currentDeliveryType,
    loading,
    branchInfo,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadBranchInfo,
      showLoading,
      hideLoading,
      setDeliveryType,
      setTableId,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BaseLayout);
